import { DEF_SCHED, DEF_THEME, DEFAULT_EQUIP, DEFAULT_TARIF } from "../../constants";
import { isSupabaseReady, supabase } from "../../services/supabase";
import { logger, toLogError } from "../../utils/logger";

/**
 * Préférences coach (hors navigation UI).
 */
export function createSettingsSlice(set, get) {
  return {
    coachSchedule: DEF_SCHED,
    coachName: "",
    brandName: "",
    logoUrl: "",
    theme: DEF_THEME,
    equipment: DEFAULT_EQUIP,
    coachEmail: "",
    coachPhone: "",
    coachProfile: "",
    sessionTarif: DEFAULT_TARIF,
    defaultSessionDuration: 60,
    billingMode: "session",
    caObjectif: 5000,
    /** Objectif CA brut Finances : { mode:'fixed', amount } | { mode:'variable', months: { "1": n, ... } } */
    revenueGoal: { mode: "fixed", amount: 5000 },
    /** Services à la personne (affichage / exports futurs) */
    isSAP: false,
    /** ISO 4217 */
    devise: "EUR",
    /** Dernière méthode utilisée pour « Marquer payé » — onglet Paiements */
    lastPaymentMethod: "virement",

    setCoachSchedule: (v) => set({ coachSchedule: v }),
    setCoachName: (v) => set({ coachName: v }),
    setBrandName: (v) => set({ brandName: v }),
    setLogoUrl: (v) => set({ logoUrl: v }),
    setTheme: (v) => set({ theme: v }),
    setEquipment: (fn) => set((s) => ({ equipment: typeof fn === "function" ? fn(s.equipment) : fn })),
    setCoachEmail: (v) => set({ coachEmail: v }),
    setCoachPhone: (v) => set({ coachPhone: v }),
    setSessionTarif: (v) => set({ sessionTarif: v }),
    setDefaultSessionDuration: (v) => set({ defaultSessionDuration: v }),
    setCaObjectif: (v) => set({ caObjectif: v }),
    setRevenueGoal: (v) => set({ revenueGoal: v }),
    setIsSAP: (v) => set({ isSAP: !!v }),
    setDevise: (v) => set({ devise: v }),
    setLastPaymentMethod: (v) => set({ lastPaymentMethod: typeof v === "string" && v ? v : "virement" }),

    handleSettingsSave: (updates) => {
      const patch = {};
      if (updates.schedule) patch.coachSchedule = updates.schedule;
      if (updates.coachName !== undefined) patch.coachName = updates.coachName;
      if (updates.brandName !== undefined) patch.brandName = updates.brandName;
      if (updates.logoUrl !== undefined) patch.logoUrl = updates.logoUrl;
      if (updates.theme) patch.theme = updates.theme;
      if (updates.equipment) patch.equipment = updates.equipment;
      if (updates.coachEmail !== undefined) patch.coachEmail = updates.coachEmail;
      if (updates.coachPhone !== undefined) patch.coachPhone = updates.coachPhone;
      if (updates.coachProfile !== undefined) patch.coachProfile = updates.coachProfile;
      if (updates.sessionTarif !== undefined) patch.sessionTarif = updates.sessionTarif;
      if (updates.defaultSessionDuration !== undefined) patch.defaultSessionDuration = updates.defaultSessionDuration;
      if (updates.billingMode !== undefined) patch.billingMode = updates.billingMode;
      if (updates.caObjectif !== undefined) patch.caObjectif = updates.caObjectif;
      if (updates.revenueGoal !== undefined) patch.revenueGoal = updates.revenueGoal;
      if (updates.isSAP !== undefined) patch.isSAP = updates.isSAP;
      if (updates.devise !== undefined) patch.devise = updates.devise;
      set(patch);

      const coachId = get().coachId;
      if (isSupabaseReady(coachId) && supabase) {
        void (async () => {
          try {
            const { data: row, error: rErr } = await supabase.from("coaches").select("settings").eq("id", coachId).single();
            if (rErr) throw rErr;
            const st = get();
            const merged = {
              ...(row?.settings && typeof row.settings === "object" ? row.settings : {}),
              caObjectif: st.caObjectif,
              revenueGoal: st.revenueGoal,
              defaultSessionPrice: st.sessionTarif,
              isSAP: st.isSAP,
              devise: st.devise,
            };
            const { error: uErr } = await supabase.from("coaches").update({ settings: merged }).eq("id", coachId);
            if (uErr) throw uErr;
          } catch (e) {
            logger.error("handleSettingsSave coach.settings", toLogError(e));
          }
        })();
      }
    },
  };
}
